import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Images } from '../../utils/imageConstants';
import { startSocialSignIn, type SocialProvider } from '../../services/cognitoOAuth';
import { resolvePostAuthRedirect, stashSocialAuthRedirect } from '../../helper/helper';

/** Same handler for both login and signup — Cognito Hosted UI has no separate social signup endpoint. */
const SocialAuthButtons: React.FC = () => {
  const [loadingProvider, setLoadingProvider] = useState<SocialProvider | null>(null);
  const location = useLocation();

  const handleClick = async (provider: SocialProvider) => {
    if (loadingProvider) return;
    setLoadingProvider(provider);
    try {
      // Cognito's Hosted UI always returns to a fixed redirect_uri, not wherever the app started —
      // stash the intended post-login destination now so SocialAuthCallback can pick it back up.
      stashSocialAuthRedirect(resolvePostAuthRedirect(location.search));
      await startSocialSignIn(provider);
    } catch {
      toast.error('Something went wrong. Please try again.');
      setLoadingProvider(null);
    }
  };

  return (
    <div className="social-auth-section">
      <div className="social-divider">
        <span>OR</span>
      </div>
      <div className="social-buttons">
        <button
          type="button"
          className="btn-social"
          onClick={() => handleClick('Google')}
          disabled={!!loadingProvider}
        >
          <img src={Images.google_icon} alt="" aria-hidden />
          Continue with Google
        </button>
        <button
          type="button"
          className="btn-social"
          onClick={() => handleClick('SignInWithApple')}
          disabled={!!loadingProvider}
        >
          <img src={Images.apple_icon} alt="" aria-hidden />
          Continue with Apple
        </button>
      </div>
    </div>
  );
};

export default SocialAuthButtons;
